import { createSlice } from "@reduxjs/toolkit";

const fileDetailsSidebarSlice = createSlice({
  name: "fileDetailsSidebar",
  initialState: {
    isFileSideBarOpen: false, // global state
    fileDetails: undefined,
  },
  reducers: {
    openFileSideBar: (state) => {
      state.isFileSideBarOpen = true;
    },
    closeFileSideBar: (state) => {
      state.isFileSideBarOpen = false;
    },
    setFileDetails: (state, action) => {
      state.fileDetails = action.payload;
    },
  },
});

export const { openFileSideBar, closeFileSideBar, setFileDetails } =
  fileDetailsSidebarSlice.actions;

export default fileDetailsSidebarSlice;
